/*
 * ---------------------------------------------------------------------
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 WALC Inc. Inc. All Rights Reserved.
 *
 * file=header.ts
 *
 * This software is the confidential and proprietary information of WALC Inc.
 * (Confidential Information). You shall not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * you entered into with WALC Inc.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * <summary>: 画面上部のヘッダー。言語切替を出す環境では右端に置く。
 * ---------------------------------------------------------------------
 */


import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { I18nService } from '../../core/i18n/i18n.service';
import { LanguageSwitcher } from '../language-switcher/language-switcher';

@Component({
  selector: 'app-header',
  imports: [LanguageSwitcher],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
  // ヘッダーは全画面（エラー画面を含む）に出るため、ここで I18nService を生成して
  // <html lang> と題名を表示言語に合わせる。
  protected readonly switcherEnabled = inject(I18nService).switcherEnabled;
}
